import { forwardRef, type ReactNode, type Ref } from "react";

import clsx from "clsx";

interface Props {
  title: ReactNode;
  hasFocus?: boolean;
  onSelect: () => void;
  getItemProps?: (props: any) => Record<string, unknown>;
}

export const QuickSelectButton = forwardRef(
  (
    { title, hasFocus, onSelect, getItemProps }: Props,
    ref: Ref<HTMLButtonElement>,
  ) => {
    return (
      <button
        ref={ref}
        tabIndex={hasFocus ? 0 : -1}
        className={clsx(
          "button bg-v2-primary text-v2-primary border border-v2-secondary md flex items-center gap-1.5 h-10 pl-2.5 pr-4 rounded-full",
          "text-left group hover:border-v2-action hover:bg-v2-highlight-information",
          {
            "border-cosmic bg-cosmic-4": hasFocus,
            "hover:bg-v2-primary hover:border-gray":
              hasFocus !== undefined && !hasFocus,
          },
        )}
        {...(getItemProps
          ? getItemProps({
              onClick: () => {
                onSelect();
              },
            })
          : {
              onClick: () => {
                onSelect();
              },
            })}
      >
        {title}
      </button>
    );
  },
);
